<h5>Referrals</h5>

@if (!loadingReferralMatchVerifications) {
  @if (anyReferralMatchVerifications) {
    <div>
      <p>The referrals have been provided as evidence for these prescriptions</p>
    </div>
  } @else {
    <p>There are no referrals.</p>
  }
  @if (referrals.length > 0) {
    <div>
      <strong>Patient Referrals From EHR Feeds</strong>
      <app-referrals-standard-listing
        [eligibleReferrals]="referrals"
        [compactClientView]="true" />
    </div>
  }
  @if (ehrReferralVerifications.length > 0) {
    <div>
      <strong>Referral Evidence Found in EHR</strong>
      <app-referrals-ehr-listing
        [ehrReferralVerifications]="ehrReferralVerifications"
        [compactClientView]="true" />
    </div>
  }
  @if (clientReferralVerifications.length > 0) {
    <div>
      <strong>Patient Referrals From Client Tasks</strong>
      <app-referrals-client-listing
        [clientReferralVerifications]="clientReferralVerifications"
        [compactClientView]="true" />
    </div>
  }
  @if (clientDateReferralMatchVerifications.length > 0) {
    <hr />
    <p>Client has indicated they have sufficient referral documentation.</p>
    <strong>DOCUMENTATION DATE(S)</strong>
    @if (clientReferralVerificationDates) {
      <div>
        {{ clientReferralVerificationDates }}
      </div>
    } @else {
      <p>No dates provided.</p>
    }
  }
} @else {
  <mat-spinner [diameter]="30" />
}

